import clsx from 'clsx'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  label?: string
  className?: string
  fullScreen?: boolean
}

export default function LoadingSpinner({
  size = 'md',
  label,
  className,
  fullScreen = false
}: LoadingSpinnerProps) {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3'
  }

  const spinner = (
    <div className={clsx('flex flex-col items-center gap-3', className)}>
      <div
        className={clsx(
          'border-primary-500 border-t-transparent rounded-full animate-spin',
          sizes[size]
        )}
      />
      {label && (
        <span className="text-sm text-surface-400">{label}</span>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-surface-950/80 backdrop-blur-sm z-50">
        {spinner}
      </div>
    )
  }

  return spinner
}
